export function makeModal(cssPath) {
  return {
    type: '$Modal',
    cssPath,
  };
}

export function makeBtn(cssPath) {
  return {
    type: '$Button',
    cssPath,
  };
}

// NOTE: Please don't use makeInput use special input like InputText, InputNumber and etc
// export function makeInput(cssPath) {
//   return {
//     type: '$Input',
//     cssPath
//   };
// }
// window.makeInput = makeInput;

export function makeInputText(cssPath) {
  return {
    type: '$InputText',
    cssPath,
  };
}
window.makeInputText = makeInputText;

export function makeInputNumber(cssPath) {
  return {
    type: '$InputNumber',
    cssPath,
  };
}
window.makeInputNumber = makeInputNumber;

export function makeInputRange(cssPath) {
  return {
    type: '$InputRange',
    cssPath,
  };
}
window.makeInputRange = makeInputRange;

export function makeTextarea(cssPath) {
  return {
    type: '$Textarea',
    cssPath,
  };
}
window.makeTextarea = makeTextarea;

export function makeSelect(cssPath) {
  return {
    type: '$Select',
    cssPath,
  };
}
window.makeSelect = makeSelect;

export function makeInputTags(cssPath) {
  return {
    type: '$InputTags',
    cssPath,
  };
}
window.makeInputTags = makeInputTags;

export function makeCheckbox(cssPath) {
  return {
    type: '$Checkbox',
    cssPath,
  };
}
window.makeCheckbox = makeCheckbox;

export function makeVideo(cssPath) {
  return {
    type: '$Video',
    cssPath,
  };
}
